
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actualite/[slug]",
      function () {
        return require("private-next-pages/actualite/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actualite/[slug]"])
      });
    }
  